'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { List, Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormState from 'MeetingsLib/models/FormState';
import UIForm from 'UIComponents/form/UIForm';
import BookingFormField from './BookingFormField';
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import CustomFormInputs from 'MeetingsLib/components/input/CustomFormInputs';
export default class BookingFormFields extends Component {
  constructor(...args) {
    super(...args);

    this.renderField = fieldName => {
      const {
        formStateValidation,
        formState,
        setFormValue,
        disabled
      } = this.props;
      return /*#__PURE__*/_jsx(BookingFormField, {
        fieldName: fieldName,
        validation: formStateValidation.get(fieldName),
        fieldValue: disabled ? '' : formState.get(fieldName),
        isRequired: true,
        fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `prebook.details.field.${fieldName}`
        }),
        setFormValue: setFormValue,
        autocomplete: "on",
        disabled: disabled
      });
    };

    this.renderCustomFormFields = () => {
      const {
        formFields,
        formStateValidation,
        formState,
        setFormValue,
        disabled
      } = this.props;
      return /*#__PURE__*/_jsx(CustomFormInputs, {
        formFields: formFields,
        formStateValidation: formStateValidation.get('customFormFields'),
        customFormFields: formState.get('customFormFields'),
        onCustomFormFieldChange: setFormValue,
        disabled: disabled
      });
    };

    this.renderNameFields = () => {
      const {
        disabled
      } = this.props;
      return /*#__PURE__*/_jsx(FullNameInput, {
        direction: "row",
        wrap: "wrap",
        givenNameInput: this.renderField('firstName'),
        familyNameInput: this.renderField('lastName'),
        disabled: disabled
      });
    };
  }

  render() {
    const className = "p-bottom-4 p-x-8";
    return /*#__PURE__*/_jsxs(UIForm, {
      className: className,
      children: [this.renderNameFields(), this.renderField('email'), this.renderCustomFormFields()]
    });
  }

}
BookingFormFields.propTypes = {
  centerPropertyForm: PropTypes.bool,
  isLastStep: PropTypes.bool,
  disabled: PropTypes.bool,
  formFields: PropTypes.instanceOf(List).isRequired,
  formStateValidation: PropTypes.instanceOf(ImmutableMap).isRequired,
  formState: PropTypes.instanceOf(FormState),
  setFormValue: PropTypes.func.isRequired
};